export const hotDeals = [
  {
    slug: 'taobao-618-coupon-guide',
    title: '淘宝618优惠券全攻略',
    excerpt: '最高省500元，手把手教你领',
    image: 'https://readdy.ai/api/search-image?query=Taobao%20shopping%20app%20with%20red%20envelope%20and%20discount%20badges%2C%20warm%20orange%20festive%20atmosphere%2C%20minimalist%20cream%20background%2C%20clean%20modern%20style&width=800&height=600&seq=hot-taobao-01&orientation=landscape',
    tag: '限时',
    tagColor: 'primary',
  },
  {
    slug: 'free-online-courses-2026',
    title: '免费在线课程资源合集',
    excerpt: '编程到设计一应俱全',
    image: 'https://readdy.ai/api/search-image?query=Online%20education%20platform%20on%20laptop%20screen%2C%20teal%20and%20green%20learning%20theme%2C%20minimalist%20cream%20background%2C%20clean%20modern%20style&width=800&height=600&seq=hot-courses-01&orientation=landscape',
    tag: '免费',
    tagColor: 'accent',
  },
  {
    slug: 'video-membership-deals',
    title: '视频会员横向对比',
    excerpt: '哪家最值得买，帮你算清楚',
    image: 'https://readdy.ai/api/search-image?query=Streaming%20services%20logos%20on%20tablet%20screen%2C%20entertainment%20theme%2C%20warm%20taupe%20tones%2C%20minimalist%20cream%20background%2C%20clean%20style&width=800&height=600&seq=hot-video-01&orientation=landscape',
    tag: '热门',
    tagColor: 'secondary',
  },
  {
    slug: 'credit-card-points-guide',
    title: '信用卡积分最大化',
    excerpt: '每年多赚2000元的秘密',
    image: 'https://readdy.ai/api/search-image?query=Premium%20credit%20cards%20with%20golden%20coins%2C%20warm%20orange%20luxury%20theme%2C%20minimalist%20cream%20background%2C%20clean%20photography&width=800&height=600&seq=hot-credit-01&orientation=landscape',
    tag: '攻略',
    tagColor: 'primary',
  },
  {
    slug: 'starbucks-buy1get1',
    title: '星巴克买一赠一回归',
    excerpt: '抓住夏天的尾巴喝半价',
    image: 'https://readdy.ai/api/search-image?query=Iced%20coffee%20with%20summer%20vibes%20and%20green%20straw%2C%20refreshing%20cafe%20atmosphere%2C%20minimalist%20cream%20background%2C%20clean%20food%20photography&width=800&height=600&seq=hot-starbucks-01&orientation=landscape',
    tag: '餐饮',
    tagColor: 'accent',
  },
  {
    slug: 'summer-skincare-deals',
    title: '夏季护肤折扣清单',
    excerpt: '大牌平替只要零头价',
    image: 'https://readdy.ai/api/search-image?query=Natural%20skincare%20products%20with%20botanical%20elements%2C%20fresh%20summer%20vibe%2C%20minimalist%20cream%20background%2C%20clean%20beauty%20photography&width=800&height=600&seq=hot-skincare-01&orientation=landscape',
    tag: '美妆',
    tagColor: 'primary',
  },
];

export const heroSlides = [
  {
    title: '每日精选福利',
    subtitle: '海量优惠券 · 免费资源 · 会员权益',
    description: '每天更新最新福利，帮你省钱省力更省心',
    image: 'https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20lifestyle%20scene%20with%20golden%20orange%20and%20cream%20color%20palette%2C%20shopping%20bags%20gift%20boxes%20and%20discount%20tags%20floating%20elegantly%2C%20minimalist%20abstract%20background%20with%20soft%20gradients%2C%20luxurious%20warm%20lighting%2C%20clean%20composition%20with%20generous%20negative%20space&width=1800&height=800&seq=hero-main-01&orientation=landscape',
    cta: '立即探索',
    link: '/category/limited-coupons',
  },
];

export const faqs = [
  {
    question: '福利吧是什么？',
    answer: '福利吧是一个专注精选优惠、折扣、免费资源与会员权益的福利聚合平台。我们每日更新海量好物福利、限时优惠券、积分兑换及专属会员礼遇，帮助用户以最低成本享受最高品质生活。',
  },
  {
    question: '福利吧的内容更新频率是怎样的？',
    answer: '我们坚持每日更新，确保你不错过任何限时优惠和热门福利。每天早上9点准时推送当日最新福利内容，节假日的特别福利也会提前预告。',
  },
  {
    question: '福利吧推荐的优惠券靠谱吗？',
    answer: '我们团队会对每一张优惠券进行人工验证，确保优惠信息真实有效。如果发现优惠券失效，我们会第一时间更新或下架，最大程度保障用户体验。',
  },
  {
    question: '如何第一时间获取最新福利？',
    answer: '你可以将福利吧加入浏览器收藏夹，每天访问查看最新内容。我们也在计划推出微信公众号和邮件订阅功能，敬请期待！',
  },
  {
    question: '福利吧的免费资源需要付费吗？',
    answer: '完全不需要！福利吧推荐的所有免费资源都是真实免费、合法合规的。我们不会发布任何需要付费才能获取的"假免费"资源。',
  },
  {
    question: '如何联系福利吧团队？',
    answer: '你可以通过关于我们页面的联系表单与我们取得联系，也可以发送邮件至 contact@fuliba.com。商务合作请发送至 biz@fuliba.com。',
  },
];

export const stats = [
  { value: '50万+', label: '活跃用户' },
  { value: '3000+', label: '每日更新福利' },
  { value: '99.2%', label: '优惠券有效率' },
  { value: '5000万+', label: '累计帮用户节省' },
];